module.exports = __webpack_public_path__ + "static/media/stereo.ecdc8088.png";